import capitalize from 'lodash/capitalize'

export function toTitleCase(string = ''): string {
  return string
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ')
}
